"use client";

import { c as _c } from "react/compiler-runtime";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
import { useNowMinting } from "@/hooks/useNowMinting";
import { useWaveDropsLeaderboard, WaveDropsLeaderboardSort } from "@/hooks/useWaveDropsLeaderboard";
import { useWaveDecisions } from "@/hooks/waves/useWaveDecisions";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import Link from "next/link";
import { LeadingCard } from "./LeadingCard";
import { NextMintCard } from "./NextMintCard";
const SKELETON_KEYS = ["coming-up-skeleton-1", "coming-up-skeleton-2", "coming-up-skeleton-3"];
export function NextMintLeadingSection() {
  const $ = _c(46);
  const {
    seizeSettings,
    isLoaded
  } = useSeizeSettings();
  const {
    nft: nowMinting,
    isFetching: isNowMintingFetching
  } = useNowMinting();
  const waveId = seizeSettings.memes_wave_id;
  const t0 = waveId ?? "";
  const t1 = !!waveId;
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = {
      waveId: t0,
      enabled: t1
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    decisionPoints,
    isFetching: isWinnersFetching
  } = useWaveDecisions(t2);
  const t3 = waveId ?? "";
  const t4 = !waveId;
  let t5;
  if ($[3] !== t3 || $[4] !== t4) {
    t5 = {
      waveId: t3,
      sort: WaveDropsLeaderboardSort.RATING_PREDICTION,
      pausePolling: t4
    };
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const {
    drops,
    isFetching: isLeaderboardFetching
  } = useWaveDropsLeaderboard(t5);
  const latestDecision = decisionPoints[decisionPoints.length - 1];
  const nextMint = latestDecision?.winners[0]?.drop ?? null;
  let t6;
  if ($[6] !== nextMint?.metadata || $[7] !== nextMint?.title || $[8] !== nowMinting) {
    const nextMintTitle = nextMint?.title ?? nextMint?.metadata.find(_temp)?.data_value;
    t6 = !!nowMinting?.name && !!nextMintTitle && nowMinting.name.toLowerCase().trim() === nextMintTitle.toLowerCase().trim();
    $[6] = nextMint?.metadata;
    $[7] = nextMint?.title;
    $[8] = nowMinting;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const isNextMintSameAsNowMinting = t6;
  const showNextMint = nextMint && !isNextMintSameAsNowMinting;
  const leadingCount = showNextMint ? 2 : 3;
  let t10;
  let t11;
  let t12;
  let t7;
  let t8;
  let t9;
  if ($[10] !== drops || $[11] !== isLeaderboardFetching || $[12] !== isLoaded || $[13] !== isNowMintingFetching || $[14] !== isWinnersFetching || $[15] !== leadingCount || $[16] !== nextMint || $[17] !== showNextMint || $[18] !== waveId) {
    t12 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const leading = drops.slice(0, leadingCount);
      const isFetching = isNowMintingFetching || isWinnersFetching || isLeaderboardFetching;
      if (!isLoaded || !waveId) {
        t12 = null;
        break bb0;
      }
      let t13;
      if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = <div><span className="tw-m-0 tw-text-xl tw-font-semibold tw-tracking-tight tw-text-white md:tw-text-2xl">Coming up</span><p className="tw-mb-0 tw-mt-2 tw-text-base tw-text-iron-500">Next in queue and current vote leaders</p></div>;
        $[25] = t13;
      } else {
        t13 = $[25];
      }
      const t14 = `/waves?wave=${waveId}`;
      let t15;
      let t16;
      if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = <span>View all</span>;
        t16 = <ArrowRightIcon className="tw-size-4 tw-flex-shrink-0" aria-hidden={true} />;
        $[26] = t15;
        $[27] = t16;
      } else {
        t15 = $[26];
        t16 = $[27];
      }
      let t17;
      if ($[28] !== t14) {
        t17 = <div className="tw-mb-8 tw-flex tw-flex-col tw-items-start tw-gap-4 sm:tw-flex-row sm:tw-items-end sm:tw-justify-between">{t13}<Link href={t14} className="tw-inline-flex tw-items-center tw-gap-1.5 tw-text-sm tw-font-medium tw-text-iron-400 tw-no-underline tw-transition-colors hover:tw-text-white">{t15}{t16}</Link></div>;
        $[28] = t14;
        $[29] = t17;
      } else {
        t17 = $[29];
      }
      const header = t17;
      if (isFetching && !showNextMint && leading.length === 0) {
        let t18;
        if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
          t18 = <div className="tw-grid tw-grid-cols-1 tw-gap-6 lg:tw-grid-cols-3 lg:tw-gap-8">{SKELETON_KEYS.map(_temp2)}</div>;
          $[30] = t18;
        } else {
          t18 = $[30];
        }
        let t19;
        if ($[31] !== header) {
          t19 = <section className="tw-px-4 md:tw-px-6 lg:tw-px-8 tw-relative tw-z-10 tw-@container tw-pb-10 md:tw-pb-16"><div>{header}{t18}</div></section>;
          $[31] = header;
          $[32] = t19;
        } else {
          t19 = $[32];
        }
        t12 = t19;
        break bb0;
      }
      if (!showNextMint && leading.length === 0) {
        t12 = null;
        break bb0;
      }
      t11 = "tw-px-4 md:tw-px-6 lg:tw-px-8 tw-relative tw-z-10 tw-@container tw-pb-10 md:tw-pb-16";
      t10 = header;
      t7 = "tw-grid tw-grid-cols-1 tw-gap-6 lg:tw-grid-cols-3 lg:tw-gap-8";
      if ($[33] !== nextMint || $[34] !== showNextMint) {
        t8 = showNextMint && <NextMintCard drop={nextMint} />;
        $[33] = nextMint;
        $[34] = showNextMint;
        $[35] = t8;
      } else {
        t8 = $[35];
      }
      t9 = leading.map(_temp3);
    }
    $[10] = drops;
    $[11] = isLeaderboardFetching;
    $[12] = isLoaded;
    $[13] = isNowMintingFetching;
    $[14] = isWinnersFetching;
    $[15] = leadingCount;
    $[16] = nextMint;
    $[17] = showNextMint;
    $[18] = waveId;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t10 = $[19];
    t11 = $[20];
    t12 = $[21];
    t7 = $[22];
    t8 = $[23];
    t9 = $[24];
  }
  if (t12 !== Symbol.for("react.early_return_sentinel")) {
    return t12;
  }
  let t13;
  if ($[36] !== t7 || $[37] !== t8 || $[38] !== t9) {
    t13 = <div className={t7}>{t8}{t9}</div>;
    $[36] = t7;
    $[37] = t8;
    $[38] = t9;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  let t14;
  if ($[40] !== t10 || $[41] !== t13) {
    t14 = <div>{t10}{t13}</div>;
    $[40] = t10;
    $[41] = t13;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== t11 || $[44] !== t14) {
    t15 = <section className={t11}>{t14}</section>;
    $[43] = t11;
    $[44] = t14;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  return t15;
}
function _temp3(drop, index) {
  return <LeadingCard key={drop.id} drop={drop} rank={index + 1} />;
}
function _temp2(key) {
  return <NextMintLeadingSkeletonCard key={key} />;
}
function _temp(m) {
  return m.data_key === "title";
}
const NextMintLeadingSkeletonCard = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-border-b tw-border-white/10 tw-bg-iron-900 tw-px-2.5 tw-py-1.5 sm:tw-px-3 sm:tw-py-2"><div className="tw-h-4 tw-w-24 tw-animate-pulse tw-rounded tw-bg-iron-800/60" /><div className="tw-h-3 tw-w-16 tw-animate-pulse tw-rounded tw-bg-iron-800/60" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-flex tw-flex-col tw-overflow-hidden tw-rounded-xl tw-border tw-border-solid tw-border-white/10 tw-bg-iron-950">{t0}<div className="tw-relative tw-flex tw-aspect-[3/4] tw-max-h-[clamp(320px,70vw,500px)] tw-w-full tw-items-center tw-justify-center tw-overflow-hidden tw-bg-iron-950 tw-p-2 sm:tw-p-3"><div className="tw-h-full tw-w-full tw-animate-pulse tw-rounded-lg tw-bg-iron-900/70" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-flex tw-items-center tw-gap-2"><div className="tw-h-4 tw-w-10 tw-animate-pulse tw-rounded tw-bg-iron-800/60" /><div className="tw-h-4 tw-flex-1 tw-animate-pulse tw-rounded tw-bg-iron-800/60" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-flex tw-flex-col tw-gap-3 tw-text-left sm:tw-gap-4">{t1}<div className="tw-flex tw-flex-col tw-gap-3"><div>{t2}<div className="tw-mt-2 tw-flex tw-items-center tw-gap-2"><div className="tw-size-6 tw-animate-pulse tw-rounded-full tw-bg-iron-800/60" /><div className="tw-h-3 tw-w-24 tw-animate-pulse tw-rounded tw-bg-iron-800/60" /></div></div></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};